export default "__VITE_ASSET__qi1dTeus__"